import { render, staticRenderFns } from "./ClaimRewardsConfirmation.vue?vue&type=template&id=298be95e&"
import script from "./ClaimRewardsConfirmation.vue?vue&type=script&lang=js&"
export * from "./ClaimRewardsConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports